import { oc } from '@orpc/contract';
import { z } from 'zod';
import { success } from '../common/success.dto';
import tokenRequest, { tokenRequestSearch } from './insurance-policy.dto';

export const insurancePolicyContract = {
  byIdAndToken: oc
    .route({
      method: 'POST',
      path: '/insurance-policy/{id}',
      summary: 'Sign up using a token',
    })
    .input(
      z
        .object({
          id: z.string(),
        })
        .merge(tokenRequest),
    )
    .output(success),

  validateInsurancePolicyToken: oc
    .route({
      method: 'GET',
      path: '/insurance-policy/{id}',
      summary: 'Validate JWT payload',
    })
    .input(
      z
        .object({
          id: z.string(),
        })
        .merge(tokenRequestSearch),
    )
    .output(
      z.object({
        token: z.string(),
        authUrl: z.string(),
        // The language is only a preference for the signup page, so an invalid one must not fail the signup
        lang: z.string().optional().catch(undefined),
      }),
    ),
};

// Default export for client compatibility
export default insurancePolicyContract;
